export class LoadNotificationsCount {
    static readonly type = "[Users] Load notifications count";

    constructor(public payload: number) {}
}
